import { render, staticRenderFns } from "./BoUserField.vue?vue&type=template&id=34dd1dec&"
import script from "./BoUserField.vue?vue&type=script&lang=ts&"
export * from "./BoUserField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports